<div class="mb-4">
  <h5 class="text-[20px] text-heading font-bold mb-1 leading-none">Cash Advance</h5>
  <ul>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.dashboard">Home</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.disbursementNavigator">Disbursement</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.cashAdvance">Cash Advance</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] font-semibold font-normal inline-block mr-2">
      {{cashAdvanceId}}
    </li>
  </ul>
</div>

<div class="bg-white p-4 mb-10">
  <div *ngIf="waitHandler.processing" class="alert alert-info">We are handling your request...</div>
  <ng-container *ngIf="currentCA$|async as ca">
    <div class="grid grid-cols-12 gap-x-4">
      <div class="col-span-12 md:col-span-4 flex-centered">
        <div class="text-lg font-bold mb-4">Review Cash Advance</div>
      </div>
      <div class="col-span-12 md:col-span-4">
        <div class="flex-end">

        </div>
      </div>
      <div class="col-span-12 md:col-span-4">
        <div class="form-submit">

          <button [disabled]="waitHandler.processing"
            *ngIf="ca.RequestStatus === 'Pending' && ca.RequestedBy.ID === loginS.userData?.ID && ca.request_can_update"
            (click)="updateCA()" type="button" class="custom-button custom-button-warning">
            <i class="fa-light fa-pen-to-square"></i> Edit
          </button>

          <ng-container *ngIf="!ca.GenerateVoucher && !ca.Voucher && ca.update_status">
            <button [disabled]="waitHandler.processing" (click)="approveRequest()" type="button"
              class="custom-button custom-button-primary">
              <i class="fa-light fa-check"></i> Approve Request
            </button>

            <button [disabled]="waitHandler.processing" (click)="disapproveRequest()" type="button"
              class="custom-button">
              <i class="fa-light fa-xmark"></i> Disapprove Request
            </button>
          </ng-container>

          <button [disabled]="waitHandler.processing" *ngIf="ca.GenerateVoucher && !ca.Voucher && ca.update_status && ca.RequestStatus != 'Disapproved'"
            (click)="generateVoucher()" class="custom-button custom-button-info" type="button">
            <i class="fa-light fa-receipt text-md"></i>
            Generate Voucher
          </button>

          <button [disabled]="waitHandler.processing" *ngIf="ca.Voucher" (click)="viewVoucher()"
            class="custom-button custom-button-success" type="button">
            <i class="fa-light fa-receipt text-md"></i>
            View Voucher
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="custom-table custom-table-default custom-table-border-row">
        <thead>
          <tr>
            <th colspan="3">
              <span class="text-base">
                Information
              </span>
            </th>
            <th>
              <div class="flex-end">
                <span class="badge badge-default whitespace-nowrap">
                  {{ca.Status||'No Status'}}
                </span>

                <ng-container [ngSwitch]="ca.RequestStatus">
                  <span *ngSwitchCase="'Approved'" class="badge badge-green whitespace-nowrap">
                    {{ca.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchCase="'Disapproved'" class="badge badge-red whitespace-nowrap">
                    {{ca.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchCase="'Pending'" class="badge badge-yellow whitespace-nowrap">
                    {{ca.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchDefault class="badge badge-default whitespace-nowrap">
                    {{ca.RequestStatus||'No Status'}}
                  </span>
                </ng-container>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2">CA Amount</td>
            <td colspan="2">
              <div class="text-end font-bold text-base">{{ca.Amount|currency:'₱ '}}</div>
            </td>
          </tr>
          <tr>
            <td colspan="2">Request By</td>
            <td colspan="2">
              <div class="text-end">
                <span *ngIf="ca.RequestedBy as by">
                  ({{Helper.users.formatUID(by.ID)}}) {{by.LastName}}, {{by.FirstName}}
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">Reference Number</td>
            <td colspan="2" class="text-end">{{ca.CntrlNumber}}</td>
          </tr>
          <tr>
            <td colspan="2">Purpose</td>
            <td colspan="2" class="text-end">{{ca.Purpose}}</td>
          </tr>
          <tr>
            <td colspan="2">Description</td>
            <td colspan="2" class="text-end">{{ca.Description}}</td>
          </tr>
          <tr>
            <td colspan="2">Department</td>
            <td colspan="2" class="text-end">{{ca.ChargeTo}}</td>
          </tr>
          <tr>
            <td colspan="2">Requestor's Remarks</td>
            <td colspan="2" class="text-end">{{ca.Remarks||'No Remarks'}}</td>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th colspan="4">
              <span class="text-base">
                History
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!ca.history.length">
            <td colspan="2">You will find status history here!</td>
          </tr>
          <tr *ngFor="let item of ca.history; let i = index">
            <td><span class="text-muted whitespace-nowrap">{{item.PrevStatus||'New Request'}}</span></td>
            <td><i class="fa-thin fa-angles-right"></i></td>
            <td>
              <span [className]="i == 0 ? 'font-bold whitespace-nowrap' : 'text-muted whitespace-nowrap'">
                {{item.Status}}
              </span>
            </td>
            <td>
              <div class="text-end whitespace-nowrap">
                <span *ngIf="item.CreatedBy as by">
                  ({{Helper.users.formatUID(by.ID)}}) {{by.LastName}}, {{by.FirstName}} |
                </span>
                {{item.created_at|formatDateTime}}
              </div>
              <div class="text-end whitespace-nowrap">
                {{item.Remarks||'No Remarks'}}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>